<template>
    <div id="roleList">
        <p class="view-title">角色管理</p>
        <div class="organize">
            <organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @setTree="setTree"></organize>
        </div>
        <!-- 列表 -->
        <div class="list-box"  style="top: 77px;">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)"><span>全部</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)"><span>通用</span></div>
                <div :class="{'active':state==2}" @click="headClick(2)"><span>自定义</span></div>
            </header>
            <div class="bg">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="open(null,'add')" :disabled="!functionSetList.includes('roleEdit')||$store.state.isLook">新建角色</el-button>
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="search">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入角色名称"
                            v-model="searchVal" @keyup.enter.native="search">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li class="w-18">角色名称</li>
                        <li class="w-18">角色类型</li>
                        <li class="w-18">所属组织</li>
                        <li class="w-90 t-right">引用计数</li>
                        <li class="w-26">备注</li>
                        <li>操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li class="w-18" :title="item.name"><i class="typeicon"><img :src="item.type==1?role1:role"></i>{{item.name}}</li>
                            <li class="w-18" >{{item.type==1?"通用角色":"自定义角色"}}</li>
                            <li class="w-18" :title="item.groupName">{{item.groupName}}</li>
                            <li class="w-90 t-right">{{item.referenceCount}}</li>
                            <li class="w-26" :title="item.note">{{item.note}}</li>
                            <li class="operate">
                                <span @click="open(i,'edit')">{{changeBtn(item)&&!$store.state.isLook&&roleId!=item.id?'编辑':'查看'}}</span>
                                <span :class="{'disabled':!changeBtn(item)||$store.state.isLook||roleId==item.id}" @click="open(i,'del')">删除</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
        <!-- 弹窗 -->
        <div class="popup">
            <!-- 删除角色 -->
            <div class="popup-del" v-show='delShow'>
                <div class="popup-title">
                    删除角色<i class="el-icon-circle-close close" @click="close('del')"></i>
                </div>
                <div class="popup-lab t-left">
                    系统将删除该角色 " {{nowObj.name}} "，是否继续
                    <p class="btn-box"><el-button type="primary" :disabled="!functionSetList.includes('roleEdit')" @click='del'>确定</el-button> <el-button @click="close('del')">取消</el-button></p>
                </div>
            </div>
            <!-- 新增角色 -->
            <div class="popup-add" v-show="addShow">
                <div class="popup-title">
                    新建角色<i class="el-icon-circle-close close" @click="close('add')"></i>
                </div>
                <div class="popup-lab">
                    <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix">
                        <div class="popup-left clearfix">
                            <el-form-item prop="name" label="角色名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="角色名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <div class="popup-lab" >
                                <i class="star">*</i> 所属组织：<i><img :src="notes" title="组织层级最多支持10级" class="notes"></i>
                                <div class="or-Superior" @click='showSelect' @mouseleave="selectShow=false" v-show="ruleForm.type==2">
                                    {{orSuperior.name}}
                                    <i><img :src="down" @click="showSelect"></i>
                                    <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                        <div class="dashed">
                                            <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                    <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                </span>
                                            </el-tree>
                                        </div>
                                    </div>
                                </div>
                                <div class="or-Superior disabled3" v-show="ruleForm.type==1">
                                    {{orSuperior.name}}
                                    <i><img :src="down"></i>
                                </div>
                            </div>
                            <el-form-item prop="type" label="角色类型：" class="no-title group-pad">
                                <el-radio-group v-model="ruleForm.type">
                                    <el-radio :label=2>自定义角色</el-radio>
                                    <el-radio :label=1 :disabled="!functionSetList.includes('roleNormal')">通用角色</el-radio>
                                  </el-radio-group>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="addRemarks"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="popup-right">
                            <el-form-item prop="functionSet" label="模块权限：" class="no-title"> <el-checkbox class="functionSet" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                <p class="red null" v-show="funcNull">模块权限不能为空</p>
                                <div class="option-box clearfix">
                                    <div v-for="option,o in functionList" :key="o" >
                                        <el-checkbox @change="(val)=>itemAll(val,option,o)" v-model="option.ischecked" :label="option.id" :disabled="regMod(option)">{{option.name}}</el-checkbox>
                                        <el-checkbox-group v-model="checkedCities" @change="(label)=>{handleCheckedCitiesChange(label, option,o)}" class="option" :disabled="regMod(option)">
                                            <el-checkbox v-for="chil,c in option.children" :label="chil.id" :key="chil.id" :disabled="!functionSetList.includes(chil.code)" v-if="chil.code=='systemConfigBackup'?env=='local':true">{{chil.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="popup-lab">
                    <p class="btn-box"><el-button type="primary" @click="addRole('addForm')">确定</el-button> <el-button  @click="close('add')">取消</el-button></p>
                </div>
            </div>
            <!-- 编辑角色 -->
            <div class="popup-add" v-show="editShow">
                <div class="popup-title">
                    {{changeBtn(ruleForm)&&!$store.state.isLook?'编辑':'查看'}}角色<i class="el-icon-circle-close close" @click="close('edit')"></i>
                </div>
                <div class="popup-lab">
                    <el-form :model='ruleForm' :rules="rules" ref="editForm" class="clearfix" :disabled="!changeBtn(ruleForm)||$store.state.isLook||roleId==nowObj.id">
                        <div class="popup-left clearfix">
                            <el-form-item prop="name" label="角色名称：" autocomplete="off" class="no-title">
                                <i><img :src="notes" title="角色名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <div class="popup-lab">
                                <i class="star">*</i> 所属组织：<i><img :src="notes" title="" class="notes"></i>
                                <div class="or-Superior" @click='showSelect' @mouseleave="selectShow=false" v-show="roleId!=nowObj.id&&ruleForm.type==2 &&functionSetList.includes('roleEdit')&&!$store.state.isLook">
                                    {{orSuperior.name}}
                                    <i><img :src="down" @click="showSelect"></i>
                                    <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                        <div class="dashed">
                                            <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                                    <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                    <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                </span>
                                            </el-tree>
                                        </div>
                                    </div>
                                </div>
                                <div class="or-Superior disabled3" v-show="ruleForm.type==1||!functionSetList.includes('roleEdit')||$store.state.isLook||roleId==nowObj.id">
                                    {{orSuperior.name}}
                                    <i><img :src="down"></i>
                                </div>
                            </div>
                            <el-form-item><p>引用计数: {{ruleForm.referenceCount}}</p></el-form-item>
                            <el-form-item prop="type" label="角色类型：" class="no-title group-pad">
                                <el-radio-group v-model="ruleForm.type">
                                    <el-radio :label=2>自定义角色</el-radio>
                                    <el-radio :label=1 :disabled="!functionSetList.includes('roleNormal')">通用角色</el-radio>
                                  </el-radio-group>
                            </el-form-item>
                            <el-form-item label="备注：">
                                <i><img :src="notes" title="支持中文、英文字母、数字和下划线，由0~256个字符构成" class="notes"></i>
                                <el-input
                                    type="textarea"
                                    class="remarks"
                                    v-model="ruleForm.note"
                                    maxlength="256"
                                    show-word-limit
                                    id="editRemarks"
                                    placeholder="请输入内容">
                                </el-input>
                            </el-form-item>
                        </div>
                        <div class="popup-right">
                            <el-form-item prop="functionSet" label="模块权限：" class="no-title"> <el-checkbox class="functionSet" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                                <p class="red null" v-show="funcNull">模块权限不能为空</p>
                                <div class="option-box clearfix">
                                    <div v-for="option,o in functionList" :key="o" >
                                        <el-checkbox @change="(val)=>itemAll(val,option,o)" v-model="option.ischecked" :disabled="regMod(option)" :label="option.id">{{option.name}}</el-checkbox>
                                        <el-checkbox-group v-model="checkedCities" @change="(label)=>{handleCheckedCitiesChange(label, option,o)}" class="option" :disabled="regMod(option)">
                                            <el-checkbox v-for="chil,c in option.children" :label="chil.id" :key="chil.id" :disabled="!regFun(chil.code)" v-if="chil.code=='systemConfigBackup'?env=='local':true">{{chil.name}}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="popup-lab">
                    <p class="btn-box"><el-button :disabled="!changeBtn(ruleForm)||$store.state.isLook||roleId==nowObj.id" type="primary" @click="editRole('editForm')">确定</el-button> <el-button  @click="close('edit')">取消</el-button></p>
                </div>
            </div>
            <!-- 验证码授权 -->
            <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -218px">
                <div class="popup-title">
                    获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('function')" id="closeClear3"></i>
                </div>
                <div class="popup-lab">
                    手机号：
                    <el-input disabled v-model="phone">{{phone}}</el-input>
                </div>
                <div class="popup-lab clearfix">
                    <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                    <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                        <el-form-item prop="verifyCode">
                            <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="code-box">
                        <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                        <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                    </div>
                </div>
                <div class="popup-lab">
                    <p class="btn-box">
                        <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                        <el-button @click="close('function')" id="closeClear4">取消</el-button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/PublicAssembly/pagination"
    import Organize from "@/components/PublicAssembly/organize"
    const company=[     //企业管理
        {label:"查看",value:'companyView'},
        {label:"编辑",value:'companyEdit'},
        {label:"权限再分配",value:'companyAssign'},
    ];
    export default {
        data() {
            var valiName = (rule, value, callback) =>{
                value=value?value:'';
                if(value.length==0){
                    callback(new Error('请输入角色名称'));
                }else if(value.length>32){
                    callback(new Error('角色名称由1~32个字符构成'));
                }else{
                    callback()
                }
                // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
                // if(value == ""||value == null){
                //     callback(new Error('角色名称不能为空'));
                // }else if(!reg.test(value)){
                //     callback(new Error('请输入中文、英文字母、数字和下划线，由1~32个字符构成'))
                // }else{
                //     callback();
                // }
            }
            return {
                dataList:[],
                searchVal:'',
                recoveryName:'',
                totalCount:0,
                pageSize:0,
                pageNumber:1,
                notes:require('@/assets/image/organize/notes.png'),
                down:require('@/assets/image/organize/down.png'),
                nullData:require('@/assets/image/index/nullData.png'),
                area:require('@/assets/image/company/qyzu.png'),
                branch:require('@/assets/image/company/ptzu.png'),
                location:require('@/assets/image/company/jczu.png'),
                role:require('@/assets/image/company/role.png'),
                role1:require('@/assets/image/company/role1.png'),
                state:0,            //控制按钮颜色
                roleTree:[],
                orSuperior:{},      //上级组对象
                orSuperiorData:[],  //所属组tree结构数据
                roleId:null,        //用户当前角色id
                functionSetList:[],     //权限列表
                selectShow:false,
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                orCode:1,
                delShow:false,
                addShow:false,
                editShow:false,
                isPageNum:true,
                isisPageSize:true,
                nowObj:{},          //当前选中角色
                nowIndex:null,      //当前选中角色下标
                ruleForm:{          //表单数据
                    id:null,
                    code:null,
                    type:2,
                    groupCode:null,
                    groupName:null,
                    name:null,
                    note:null,
                    functionSet:"",
                    referenceCount:null
                },
                verifyForm:{
                    verifyCode:'',
                },
                rules:{         //验证规则
                    name:[{ required: true, message: '请输入角色名称', trigger: 'blur' },
                        { max: 32, message: '最大支持32个字符', trigger: 'blur' }],
                    type:[{required: true}],
                    verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }]
                },
                noGet:false,
                setCount:true,
                isIndeterminate: true,  //全选
                checkAll: false,
                functionList:[],    //功能集
                result:[],          //所有功能集
                checkedCities:[],   //当前选中的权限
                funcNull:false,
                isOpen:true,
                setOrcode:false,
                functionShow:false,
                VerifyArr:[],
                verifyCode:'',
                second:60,
                getCodeShow:true,
                countdownShow:false,
                phone:'',
                time:null,
                oldFunctionList:[],
                allFunction:{},
                oldNum:1,
                oldorSuperior:{},
            }
        },
        components:{
            Pagination,
            Organize
        },
        created() {
            this.$store.state.activeIndex='/roleList'
            this.getFunction()
            this.getTree('a')
            this.pageSize=this.$store.state.userConfig.rowsPerPage;
            this.phone=this.hidePhone(this.$store.state.userData.mobile);
        },
        methods: {
            // 获取列表
            getlist(parm){
                // console.log(parm)
                this.get('/Role/query',parm).then((res)=>{
                    if(res.success){
                        this.dataList=res.result.data;
                        if(this.setCount){
                            this.totalCount=res.result.totalCount;
                            this.setCount=false
                        }
                    }else{
                        this.$message({
                            message: `获取列表数据失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
            },
            setTree(){
                this.getTree()
            },
            //获取组织树
            getTree(type){
                this.get('/Group/getOrganizationTree').then((res)=>{
                    if(res.success){
                        this.roleTree=res.result;
                        this.setOrcode = true;
                        this.orCode =  this.roleTree[0].code
                        this.$store.state.treeData = this.roleTree
                        this.orSuperior = this.clone(this.$store.state.treeData[0])
                        this.oldorSuperior = this.clone(this.orSuperior)
                        this.functionSetList = this.$store.state.treeData[0].functionSet.split(',')
                        this.$store.state.expandedArr=[]
                        this.expanded(this.$store.state.treeData,1)
                        if(type == 'a'){
                            this.roleId = this.$store.state.treeData[0].roleId
                            this.getlist({pageNumber:1,length:Number(this.pageSize),type:null,keyword:"",code:this.orCode});
                            this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                        }
                        this.orSuperiorData=[]  //初始化树
                        for(let obj of res.result){
                            if(obj.roleId == this.roleId){  //获取当前角色下树数据
                                obj = this.clone(obj)
                                this.orSuperiorData.push(obj)
                                return
                            }
                        }
                    }
                })
            },
            //获取功能集
            getFunction(){
                this.get('/Function/getList').then((res)=>{
                    let result = res.result;
                    this.allFunction = this.clone(result)
                    let obj=[];
                    for(let item of result){
                        if(item.type == 1){
                            item.children=[];
                            item.ischecked=false;
                            obj.push(item)
                        }else{
                            this.result.push(item.id)
                        }
                    }
                    for(let parent of obj){
                        for(let children of result){
                            if(children.parentId == parent.id){
                              // if(children.code=='systemConfigBackup'&&this.env=='local'){
                              //   parent.children.push(children)
                              // }else if(children.code!='systemConfigBackup'){
                              //   parent.children.push(children)
                              // }
                              parent.children.push(children)
                            }
                        }
                    }
                    this.functionList = obj
                    // console.log(this.functionList)
                })
            },
            // 头部标签
            headClick(i){
                this.state=i;
                this.setCount = true;
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    code:this.orCode,
                    type:this.state==0?null:this.state,
                    keyword:"",
                }

                this.searchVal="";
                this.pageNumber = 1;
                this.getlist(parm);
            },
            // 修改分页size
            setSize(pageObj){
                if(this.isPageSize){
                    this.isPageSize=false;
                    return;
                }
                // console.log('size')
                this.pageSize=pageObj.size;
                let parm={
                    pageNumber:pageObj.number==0?1:pageObj.number,
                    length:pageObj.size,
                    type:this.state==0?null:this.state,
                    code:this.orCode,
                    keyword:this.searchVal
                }
                this.getlist(parm)
            },
            // 修改页数
            setNum(number){
                //主动修改页数不发送请求
                this.pageNumber=number;
                if(this.noGet){
                    this.noGet=false;
                    return;
                }
                if(this.oldNum == number){
                    return
                }else{
                    this.oldNum = number
                }
                let parm ={
                    pageNumber:number,
                    length:this.pageSize,
                    type:this.state==0?null:this.state,
                    code:this.orCode,
                    keyword:this.searchVal
                }
                this.getlist(parm);
            },
            // 判断修改权限按钮
            changeBtn(data){
                if(data.type==1&&this.functionSetList.includes('roleNormal')&&this.functionSetList.includes('roleEdit')){
                    return true
                }else if(data.type==2&&this.functionSetList.includes('roleEdit')){
                    return true
                }else{
                    return false
                }
            },
            // 获取的当前组
            setOrId(node){
                // console.log(node)
                this.roleId = node[0].roleId
                this.orSuperiorData = []
                for(let obj of this.$store.state.treeData){
                    if(node[0].roleId == obj.roleId){   //获取当前角色下的树数据
                        obj = this.clone(obj)
                        this.orSuperiorData.push(obj)
                    }
                }
                this.orCode=node[0].code;
                this.functionSetList = node[1]
                this.orSuperior=this.clone(node[0]);
                this.oldorSuperior = this.clone(this.orSuperior)
                this.setCount = true
                this.searchVal = null
                this.oldNum = 1
                this.pageNumber = 1
                let parm = {
                    pageNumber:1,
                    length:this.pageSize,
                    type:this.state==0?null:this.state,
                    code:this.orCode,
                }
                this.getlist(parm)
            },
            // 关闭弹窗
            close(name){
                this.$store.state.mask=false;
                let show = name + "Show";
                this[show]=false;
            },
            // 展开上级组
            showSelect(){
                var box = this.$refs.selectbox;
                this.selectShow=true;
            },
            // 获取用户点击的上级组节点
            selectId(data){
                this.orSuperior=this.clone(data);
                this.selectShow=false;
            },
            //搜索
            search(){
                this.setCount = true
                let parm = {
                    pageNumber:this.pageNumber,
                    length:Number(this.pageSize),
                    code:this.orCode,
                    keyword:this.searchVal,
                    type:this.state==0?null:this.state
                }
                this.getlist(parm);
                // console.log('sousuo')
            },
            //打开弹窗
            open(i,name){
                if(name=='del'&&!this.changeBtn(this.dataList[i])||name=='del'&&this.$store.state.isLook||name=='del'&&this.roleId==this.dataList[i].id){
                    return
                }
                if(name =='add'&&this.VerifyArr.includes(4)){
                    this.$store.state.mask=true;
                    this.functionShow = true;
                    return
                }
                if(this.VerifyArr.includes(4)&&!this.$store.state.isLook&&this.dataList[i].type==1&&this.changeBtn(this.dataList[i])){
                    this.$store.state.mask=true;
                    this.functionShow = true;
                    return
                }
                name += "Show";
                if(name == "editShow"){
                    this.nowIndex=i
                    this.get('/Role/get',{id:this.dataList[i].id}).then((res)=>{
                        if(res.success){
                            this.nowObj = res.result;
                            this.ruleForm = this.clone(this.nowObj);
                            //挂接组
                            this.orSuperior.name=this.ruleForm.groupName;
                            this.orSuperior.code=this.ruleForm.groupCode;
                            //功能集
                            this.checkedCities=this.ruleForm.functionSet.split(",").map(Number);
                            this.oldFunctionList = this.ruleForm.functionSet.split(",").map(Number);
                            this.resetState()
                            this[name]=true;
                            this.$store.state.mask=true;
                        }else{
                            this.$message({
                                type:'warning',
                                message:`获取角色数据失败：${res.message}`
                            })
                        }
                    })
                }else if(name=="addShow"){
                    //重置数据
                    this.isOpen = true;
                    this.orSuperior = this.clone(this.oldorSuperior)
                    this.checkedCities = this.$options.data().checkedCities;
                    this.ruleForm = this.$options.data().ruleForm;
                    for(let item of this.functionList){
                        item.ischecked = false
                    }
                    this[name]=true;
                    this.$store.state.mask=true;
                }else{
                    this.nowIndex=i
                    this.nowObj = this.dataList[i];
                    this[name]=true;
                    this.$store.state.mask=true;
                }
            },
            // 初始模块权限父标题状态
            resetState(){
                for(let obj of this.functionList){
                    for(let chil of obj.children){
                        let ischecked = true
                        if(!this.checkedCities.includes(chil.id)){
                            ischecked =false
                        }
                        obj.ischecked=ischecked
                    }
                }
            },
            // 功能集
            handleCheckAllChange(val) {
                if(val){
                    this.checkedCities=[];
                    let arr=[]
                    if(this.editShow){
                        arr = this.nowObj.functionSet.split(",").map(Number)  //获取当前用户的权限
                    }
                    for(let obj of this.functionList){
                        obj.ischecked=true
                        for(let item of obj.children){
                            if(this.functionSetList.includes(item.code)||arr.includes(item.id)&&!this.functionSetList.includes(item.code)){
                                this.checkedCities.push(item.id)
                            }
                        }
                    }
                }else{
                    this.checkedCities =[];
                    if(this.editShow){
                        let arr = this.nowObj.functionSet.split(",").map(Number)  //获取当前用户的权限
                        for(let obj of this.functionList){
                            obj.ischecked=true
                            for(let item of obj.children){
                                if(arr.includes(item.id)&&!this.functionSetList.includes(item.code)){
                                    this.checkedCities.push(item.id)
                                }
                            }
                        }
                    }
                    // console.log(this.nowObj.functionSet.split(",").map(Number))
                    for(let obj of this.functionList){
                        obj.ischecked=false
                    }
                    // console.log(this.checkedCities,this.functionSetList)
                    for(let id of this.checkedCities){
                        for(let o of this.allFunction){
                            if(id==o.id && o.code.indexOf('Normal')!=-1){
                                let reg = o.code.replace('Normal', '') + "Edit"
                                for(let b of this.allFunction){
                                    if(reg==b.code&&!this.checkedCities.includes(b.id)){
                                        this.checkedCities.push(b.id)
                                    }
                                }
                            }
                            if(o.code == 'groupAssign'&&this.checkedCities.includes(o.id)){
                                for(let j of this.allFunction){
                                    if(j.code=='groupEdit'&&!this.checkedCities.includes(j.id)){
                                        this.checkedCities.push(j.id)
                                    }
                                }
                            }
                        }
                    }
                }
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value,obj,i) {
                console.log(value,obj,i)
                // 取消
                if(value.length<this.oldFunctionList.length){
                    // 如果用户取消查看权限
                    if(!value.includes(obj.children[0].id)){
                        for(let item of obj.children){
                            if(this.functionSetList.includes(item.code)&&value.includes(item.id)){
                                value.splice(value.indexOf(item.id),1)
                            }
                        }
                    }else {
                        for(let item of obj.children){
                            // 用户取消编辑权限
                            if(item.code.indexOf('Edit')!=-1&&!value.includes(item.id)){
                                for(let edit of obj.children){
                                    // 当前模块下存在通用权限且选中
                                    if(edit.code.indexOf('Normal')!=-1&&value.includes(edit.id)){
                                        value.splice(value.indexOf(edit.id),1)
                                    }
                                    if(edit.code =='groupAssign'&&value.includes(edit.id)){
                                        value.splice(value.indexOf(edit.id),1)
                                    }
                                }
                            }
                        }
                    }
                    if(obj.code == "workorder"){
                        debugger
                        var newId = obj.children.find(chil=>chil.code=="workorderNew").id
                        var autoId = obj.children.find(chil=>chil.code=="workorderAuto").id
                        if(!value.includes(newId)&&value.includes(autoId)){
                            value.splice(value.indexOf(autoId),1)
                        }
                    }
                }else{ //增加
                    //如果当前模块没有选择查看功能并且选中权限不为空的话
                    if(value.length!=0){
                        // 判断当前模块的是否有其他权限已选中
                        for(let item of obj.children){
                            if(value.includes(item.id)&&obj.code!='log'&&obj.code!="group"&&this.functionSetList.includes(item.code)){
                                // 添加查看权限
                                if(!value.includes(obj.children[0].id)){
                                    value.push(obj.children[0].id)
                                }
                            }
                            if(item.code.indexOf('Normal')!=-1&&value.includes(item.id)){
                                for(let edit of obj.children){
                                    if(edit.code.indexOf('Edit')!=-1){
                                        if(!value.includes(edit.id)&&this.functionSetList.includes(edit.code)){
                                            value.push(edit.id)
                                        }
                                    }
                                }
                            }else if(item.code =='groupAssign'&&value.includes(item.id)){
                                for(let edit of obj.children){
                                    if(edit.code.indexOf('Edit')!=-1&&!value.includes(edit.id)){
                                        value.push(edit.id)
                                    }
                                }
                            }
                        }
                        if(obj.code == "workorder"){
                            debugger
                            var newId = obj.children.find(chil=>chil.code=="workorderNew").id
                            var autoId = obj.children.find(chil=>chil.code=="workorderAuto").id
                            if(!value.includes(newId)&&value.includes(autoId)){
                                value.push(newId)
                            }
                        }
                    }
                }
                let bool = true;
                for(let item of obj.children){
                    if(!value.includes(item.id)){
                        bool = false
                    }
                }

                let checkedCount = value.length;
                this.checkAll = checkedCount === this.result.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.result.length;
                this.functionList[i].ischecked=bool;
                console.log(this.checkedCities)
                this.$forceUpdate()
                this.oldFunctionList=this.clone( this.checkedCities)
            },
            itemAll(val,item){
                if(val){
                    for(let obj of item.children){
                        if(!this.checkedCities.includes(obj.id)&&this.functionSetList.includes(obj.code)){
                            this.checkedCities.push(obj.id)
                        }
                    }
                }else{
                    if(this.editShow){
                        for(let obj of item.children){
                            for(let i in this.checkedCities){
                                if(obj.id == this.checkedCities[i]&&this.functionSetList.includes(obj.code)){
                                    this.checkedCities.splice(i,1)
                                }
                            }
                            if(obj.code.indexOf('Normal')!=-1){
                                // 如果当前用户没有通用权限但通用设置选中
                                if(!this.functionSetList.includes(obj.code)&&this.checkedCities.includes(obj.id)){
                                    for(let e of item.children){
                                        if(e.code.indexOf('Edit')!=-1){
                                            // 还原编辑权限
                                            this.checkedCities.push(e.id)
                                        }
                                        if(e.code.indexOf('View')!=-1){
                                            // 还原编辑权限
                                            this.checkedCities.push(e.id)
                                        }
                                    }
                                }
                            }
                            if(obj.code=='groupAssign'){
                                // 如果当前用户没有组织权限在分配但选中
                                if(!this.functionSetList.includes(obj.code)&&this.checkedCities.includes(obj.id)){
                                    for(let e of item.children){
                                        if(e.code.indexOf('Edit')!=-1){
                                            // 还原编辑权限
                                            this.checkedCities.push(e.id)
                                        }
                                    }
                                }
                            }
                            // if(this.checkedCities.indexOf(item.id)!='-1'&&arr.includes)
                            // this.checkedCities.splice(this.checkedCities.indexOf(item.id))
                        }
                    }else{
                        for(let obj of item.children){
                            for(let i in this.checkedCities){
                                if(obj.id == this.checkedCities[i]){
                                    this.checkedCities.splice(i,1)
                                }
                            }
                        }
                    }
                }
                this.oldFunctionList = this.clone(this.checkedCities)
            },
            //删除角色
            del(i){
                let parm ={
                    id:this.nowObj.id
                }
                // console.log(this.nowIndex)
                this.get('/Role/remove',parm).then((res)=>{
                    if(res.success){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.search()
                    }else{
                        this.$message({
                            message: `删除失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                    this.$store.state.mask = false;
                    this.delShow = false;
                })
            },
            //新增角色
            addRole(name){
                this.$refs[name].validate((valid) => {
                    if(this.checkedCities.length==0){
                        this.funcNull=true;
                    }
                    if(valid && !this.funcNull){
                        let txt=this.checkedCities.toString();
                        this.ruleForm.functionSet=txt
                        // console.log(this.ruleForm.functionSet)
                        if(this.ruleForm.type==2){
                            this.ruleForm.groupCode= this.orSuperior.code;
                            this.ruleForm.groupName= this.orSuperior.name;
                        }else{
                            this.ruleForm.groupCode= '';
                            this.ruleForm.groupName= '';
                        }
                        this.post("/Role/create",this.ruleForm).then((res)=>{
                            if(res.success){
                                this.$message({
                                    message: '新建角色成功',
                                    type: 'success'
                                });
                                this.search()
                                this.addShow = false;
                                this.$store.state.mask = false;
                                this.ruleForm = this.$options.data().ruleForm;
                            }else{
                                this.$message({
                                    message: `新建角色失败：${res.message}`,
                                    type: 'warning'
                                });
                            }
                        })
                    }else{
                        // console.log('err')
                    }
                });
            },
            //编辑角色
            editRole(name){
                this.$refs[name].validate((valid) => {
                    if(this.checkedCities.length==0){
                        this.funcNull=true;
                    }
                    if(valid && !this.funcNull){
                        let txt=this.checkedCities.toString();
                        this.ruleForm.functionSet=txt
                        if(this.ruleForm.type==2){
                            this.ruleForm.groupCode= this.orSuperior.code;
                            this.ruleForm.groupName= this.orSuperior.name;
                        }else{
                            this.ruleForm.groupCode= '';
                            this.ruleForm.groupName= '';
                        }
                        this.post("/Role/update",this.ruleForm).then((res)=>{
                            // console.log(res)
                            if(res.success){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                });
                                this.dataList[this.nowIndex]=this.clone(this.ruleForm)
                            }else{
                                this.$message({
                                    message: `修改失败：${res.message}`,
                                    type: 'warning'
                                });
                            }
                            this.editShow = this.$store.state.mask = false;
                        })
                    }
                });
            },
            // 获取验证码
            getCode(){
                this.get('/UserProfile/sendVerifyCode').then((res)=>{
                    if(res.success){
                        this.getCodeShow=false
                        this.countdownShow=true
                        const TIME_COUNT = 60;
                        this.$message({
                            message: '验证码发送成功',
                            type: 'success'
                        });
                        if (!this.timer) {
                            this.second = TIME_COUNT;
                            this.show = false;
                            this.timer = setInterval(() => {
                                if (this.second > 0 && this.second <= TIME_COUNT) {
                                    this.second--;
                                } else {
                                    this.getCodeShow = true;
                                    this.countdownShow=false;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000)
                        }
                    }else{
                        this.$message({
                            message: `验证码发送失败：${res.message}`,
                            type: 'warning'
                        });
                    }
                })
            },
            // 用户提权
            Privilege(){
                this.$refs.verifyCode.validate((valid) => {
                    if (valid) {
                        this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                            if(res.success){
                                this.$message({
                                    message:'提权成功',
                                    type:'success'
                                })
                                this.VerifyArr.splice(this.VerifyArr.indexOf(4),1)
                                localStorage.setItem('verifyCodeModule',this.VerifyArr)
                                this.$store.state.mask=false
                                this.functionShow=false
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                                this.verifyForm.verifyCode = ''
                            }else{
                                this.$message({
                                    message:`提权失败：${res.message}`,
                                    type:'warning'
                                })
                            }
                        })
                    }
                })
            },
            regFun(code){
                if(code=='groupEdit'&&this.editShow){
                    for(let Assign of this.allFunction){
                        if(Assign.code =='groupAssign'&&!this.functionSetList.includes(Assign.code)){
                            if(!this.checkedCities.includes(Assign.id)){
                                return true
                            }else if(this.checkedCities.includes(Assign.id)){
                                return false
                            }
                        }
                        if(Assign.code == 'groupAssign'&&this.functionSetList.includes(Assign.code)){
                            return true
                        }else if(Assign.code == 'groupAssign'&&!this.functionSetList.includes(Assign.code)){
                            return false
                        }
                    }
                }else if(this.functionSetList.includes(code)&&code.indexOf('Edit')!=-1&&this.editShow){
                    for(let obj of this.allFunction){
                        if(code == obj.code){
                            if(!this.functionSetList.includes(code)){
                                return false
                            }else{
                                let reg = code.replace('Edit', '') + "Normal"
                                // console.log(reg,this.allFunction)
                                let d =false
                                for(let item of this.allFunction){
                                    if(item.code==reg){
                                        if(this.checkedCities.includes(item.id)){
                                            return this.functionSetList.includes(item.code)
                                        }
                                        d=item
                                    }
                                }
                                if(d&&this.checkedCities.includes(d.id)){
                                    return this.functionSetList.includes(d.code)
                                }else{
                                    return true
                                }
                            }
                        }
                    }
                }else if(this.functionSetList.includes(code)&&code.indexOf('View')!=-1&&this.editShow){
                    for(let obj of this.allFunction){
                        if(code == obj.code){
                            if(!this.functionSetList.includes(code)){
                                return false
                            }else{
                                let reg = code.replace('View', '') + "Normal"
                                // console.log(reg,this.allFunction)
                                let d =false
                                for(let item of this.allFunction){
                                    if(item.code==reg){
                                        if(this.checkedCities.includes(item.id)){
                                            return this.functionSetList.includes(item.code)
                                        }
                                        d=item
                                    }
                                }
                                if(d&&this.checkedCities.includes(d.id)){
                                    return this.functionSetList.includes(d.code)
                                }else{
                                    return true
                                }
                            }
                        }
                    }
                }else{
                    return this.functionSetList.includes(code)
                }
            },
            regMod(obj){
                return !this.functionSetList.includes(obj.code+'Assign')
                this.$forceUpdate()
            }
        },
        watch: {
            //用户选择组
            checkedCities(){
                let length = this.checkedCities.length;
                if(length == 0 && !this.isOpen){
                    this.funcNull=true;
                }else{
                    this.isOpen = false;
                    this.funcNull=false;
                }
            }
        },
    };
</script>
<style scoped>
    .or-Superior{
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 10px;
        position: relative;
        box-sizing: border-box;
    }
    .red{
        color: #F56C6C;
        line-height: 20px;
        font-size: 12px;
        position: absolute;
        display: none;
    }
    .select-box{
        position: absolute;
        left: -1px;
        top: 32px;
        border: 1px solid #e5e5e5;
        max-height: 315px;
        overflow: auto;
        min-width: 352px;
        min-height: 242px;
        max-width: 522px;
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .or-Superior i{
        float: right;
    }
    .or-Superior img{
        width: 22px;
        margin-top: 6px;
    }
    .root-obj{
        padding-left: 10px;
        cursor:pointer;
        position: relative;
        line-height: 28px;
        top: 4px;
    }
    .root-obj:hover{
        background-color: #f5f7fa;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top: -43px;
    }
    .organize{
        position: absolute;
        top: 36px;
        bottom: 0;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        float: left;
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 36px;
        left: 328px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: 88%;
        max-height: 88% !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 140px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
        width: 100%;
        height: 90%;
    }
    .m-t-16{
        margin-top: 16px;
    }
    .m-t-48{
        margin-top: 48px;
    }
    .popup>div{
        position: fixed;
        top: 0;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-40%;
        width: 80%;
        background-color: #fff;
        z-index: 9999;
        padding-bottom: 30px;
    }
    .popup-del{
        width: 578px !important;
        margin-left: -406px !important;
        height: 284px !important;
        top: 10% !important;
    }
    .group-pad .el-radio-group{
        padding-top: 7px !important;
        padding-left: 15px !important;
    }
    .popup-add{
        height:765px ;
    }
    .popup-left{
        width: 30%;
        float: left;
        text-align: left;
    }
    .popup-right{
        float: left;
        margin-left: 4%;
        width: 66%;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 22px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .w-26{
        width: 26% !important;
    }
    .functionSet{
        float: left;
        text-align: left;
        width: 80%;
        margin: 3px 0 0 15px;
    }
    .option-box{
        width: 100%;
        text-align: left;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        height: 544px;
        overflow: auto;
        margin-top: 6px;
    }
    .option-box>div{
        width: 175px;
        min-height: 150px;
        margin-bottom: 12px;
    }
    .m-l-24{
        margin-left: 24px;
    }
    .option{
        line-height: 24px !important;
        margin-left: 24px;
    }
    .null{
        display: block;
        top: 26px;
    }
</style>
<!-- 修改默认样式 -->
<style>
    #roleList .tree-box .el-tree-node__content{
        padding-left: 14px !important;
    }
    #roleList .tree .el-tree-node{
        width: 263px;
        padding-right: 30px;
        box-sizing: border-box;
    }
    #roleList .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #roleList .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 12px !important;
    }
    #roleList .popup .el-form-item__label{
        padding: 0 !important;
    }
    #roleList .popup .el-form-item__content{
        line-height: 34px !important;
    }
    #roleList .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #roleList .search .el-icon-search{
        line-height: 34px !important;
    }
    #roleList .el-button--primary.is-disabled{
        background-color: #a0cfff ;
        border-color: #a0cfff ;
    }
    #roleList .remarks textarea{
        width: 100% !important;
        height: 235px !important;
        border: 1px solid #dedede !important;
        resize: none !important;
        padding:5px !important;
        box-sizing: border-box !important;
        line-height: 20px !important;
        overflow: hidden !important;
    }
</style>




// WEBPACK FOOTER //
// src/components/Role/roleList.vue